import { Button } from "@mui/material"

export function BasicButton({ text, onClick, icon, ...props }) {
    return (
        <Button size="small" color="primary" variant="contained" onClick={onClick} startIcon={icon} {...props}>
            {text}
        </Button>
    )
}
